// 场景目录数据
// atmo 字段映射到 /api/recommendations/{atmo} 端点

const _ATMOS = {
  zen: 'zen',       // 放松→禅
  rain: 'rain',     // 紧张→雨夜
  night: 'night',   // 恐怖→午夜
  ancient: 'ancient', // 古风→古代
  cafe: 'cafe',     // 慵懒→咖啡馆
  autumn: 'autumn', // 叙事→秋夜
  study: 'study',   // 学习
  nature: 'nature', // 自然
};

export const scenes = [
  // === 放松 / 舒缓解压 ===
  {
    id: "morning-cafe",
    name: "晨曦咖啡馆",
    nameEn: "Morning Café",
    emoji: "☕",
    category: "relaxing",
    tags: ["咖啡馆", "清晨", "温暖", "ambient"],
    tagsEn: ["cafe", "morning", "warm", "ambient"],
    mood: ["放松", "慵懒", "温暖"],
    moodEn: ["relaxed", "lazy", "warm"],
    useCases: ["视频剪辑", "直播背景", "专注工作"],
    useCasesEn: ["Video Editing", "Live Stream", "Focus"],
    description: "阳光透过窗帘洒进老式咖啡馆，爵士乐轻柔地流淌。一杯热咖啡，一本翻开的书，城市刚刚醒来的样子。",
    descriptionEn: "Sunlight streams through lace curtains into an old café as jazz fills the air. A warm coffee, an open book — the city just waking up.",
    audioUrl: "/audio/morning-cafe.mp3",
    duration: 180,
    plays: 1243,
    image: "https://images.unsplash.com/photo-1501339847302-ac426a4a7cbb?w=400&h=300&fit=crop",
    pricing: { personal: 0, perUse: 2, monthly: 9 },
    atmo: "cafe",
  },
  {
    id: "zen-garden",
    name: "禅意庭院",
    nameEn: "Zen Garden",
    emoji: "🏯",
    category: "relaxing",
    tags: ["禅", "日式", "冥想", "宁静"],
    tagsEn: ["zen", "japanese", "meditation", "serenity"],
    mood: ["平静", "空灵", "专注"],
    moodEn: ["calm", "ethereal", "focused"],
    useCases: ["冥想引导", "瑜伽背景", "睡前"],
    useCasesEn: ["Meditation", "Yoga", "Bedtime"],
    description: "枯山水，白砂耙出的涟漪。远处传来风铃的声响，心慢慢沉静下来。",
    descriptionEn: "A dry landscape garden with ripples raked in white sand. Wind chimes echo in the distance as the mind settles into stillness.",
    audioUrl: "/audio/zen-garden.mp3",
    duration: 240,
    plays: 892,
    image: "https://images.unsplash.com/photo-1528360983277-13d401cdc186?w=400&h=300&fit=crop",
    pricing: { personal: 0, perUse: 2, monthly: 9 },
    atmo: "zen",
  },
  {
    id: "library-whispers",
    name: "图书馆私语",
    nameEn: "Library Whispers",
    emoji: "📚",
    category: "relaxing",
    tags: ["图书馆", "安静", "翻书声", "学习"],
    tagsEn: ["library", "quiet", "pages", "study"],
    mood: ["专注", "沉静", "思考"],
    moodEn: ["focused", "serene", "thoughtful"],
    useCases: ["学习背景", "专注工作", "白噪音"],
    useCasesEn: ["Study", "Deep Work", "White Noise"],
    description: "老式图书馆，翻书声和远处的脚步声。窗外的光线慢慢移动，时间在这里变得很慢。",
    descriptionEn: "An old library — pages turning, footsteps in the distance. Sunlight crawls slowly across the floor. Time moves differently here.",
    audioUrl: "/audio/library-whispers.mp3",
    duration: 300,
    plays: 2104,
    image: "https://images.unsplash.com/photo-1507842217343-583bb7270b66?w=400&h=300&fit=crop",
    pricing: { personal: 0, perUse: 2, monthly: 9 },
    atmo: "study",
  },

  // === 紧张 / 悬疑 ===
  {
    id: "cyberpunk-rain",
    name: "赛博朋克雨夜",
    nameEn: "Cyberpunk Rain",
    emoji: "🌆",
    category: "tense",
    tags: ["赛博朋克", "雨夜", "霓虹", "未来"],
    tagsEn: ["cyberpunk", "rainy night", "neon", "futuristic"],
    mood: ["紧张", "神秘", "科技感"],
    moodEn: ["tense", "mysterious", "high-tech"],
    useCases: ["游戏BGM", "预告片", "视频剪辑"],
    useCasesEn: ["Game BGM", "Trailer", "Video Editing"],
    description: "霓虹灯在雨幕中模糊，高楼之间的飞行器划过。数据流在黑暗中涌动，这是一个没有温度的城市。",
    descriptionEn: "Neon lights blur through sheets of rain. Hover-vehicles streak between skyscrapers. Data flows pulse through the dark — a city without warmth.",
    audioUrl: "/audio/cyberpunk-rain.mp3",
    duration: 185,
    plays: 3421,
    image: "https://images.unsplash.com/photo-1550745165-9bc0b252726f?w=400&h=300&fit=crop",
    pricing: { personal: 0, perUse: 3, monthly: 9 },
    atmo: "rain",
  },
  {
    id: "heist-countdown",
    name: "惊天魔盗团",
    nameEn: "Heist Countdown",
    emoji: "💎",
    category: "tense",
    tags: ["盗窃", "倒计时", "紧张", "悬疑"],
    tagsEn: ["heist", "countdown", "tense", "suspense"],
    mood: ["紧张", "刺激", "心跳加速"],
    moodEn: ["tense", "thrilling", "heart-pounding"],
    useCases: ["预告片", "短视频", "游戏BGM"],
    useCasesEn: ["Trailer", "Short Video", "Game BGM"],
    description: "保险柜的密码盘在转，倒计时一秒秒逼近。队友的呼吸声在耳机里清晰可闻。",
    descriptionEn: "The safe dial spins as the countdown ticks closer. Your teammate's breathing is loud in the headset. Time is running out.",
    audioUrl: "/audio/heist-countdown.mp3",
    duration: 156,
    plays: 1876,
    image: "https://images.unsplash.com/photo-1518709268805-4e9042af9f23?w=400&h=300&fit=crop",
    pricing: { personal: 0, perUse: 3, monthly: 9 },
    atmo: "rain",
  },
  {
    id: "market-war",
    name: "商战风云",
    nameEn: "Corporate Warfare",
    emoji: "📈",
    category: "tense",
    tags: ["商战", "紧迫", "博弈", "悬疑"],
    tagsEn: ["corporate", "urgent", "power play", "suspense"],
    mood: ["紧张", "压迫", "焦虑"],
    moodEn: ["tense", "oppressive", "anxious"],
    useCases: ["商战视频", "纪录片", "戏剧配乐"],
    useCasesEn: ["Corporate Video", "Documentary", "Drama Score"],
    description: "交易大厅的屏幕闪烁，数字在跳动。每个人都在算计，而真正的赢家永远是那个最冷静的人。",
    descriptionEn: "Trading floor screens flicker as numbers jump. Everyone is calculating, but the real winner is always the one who stays coolest.",
    audioUrl: "/audio/market-war.mp3",
    duration: 210,
    plays: 934,
    image: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=400&h=300&fit=crop",
    pricing: { personal: 0, perUse: 3, monthly: 9 },
    atmo: "rain",
  },

  // === 恐怖 / 阴暗 ===
  {
    id: "abandoned-hospital",
    name: "废弃医院",
    nameEn: "Abandoned Hospital",
    emoji: "🏥",
    category: "horror",
    tags: ["恐怖", "废弃", "阴暗", "惊悚"],
    tagsEn: ["horror", "abandoned", "dark", "creepy"],
    mood: ["恐惧", "不安", "压迫"],
    moodEn: ["fear", "unease", "oppression"],
    useCases: ["恐怖游戏", "惊悚视频", "万圣节"],
    useCasesEn: ["Horror Game", "Thriller Video", "Halloween"],
    description: "走廊尽头的灯忽明忽暗，某个病房里传来金属器械碰撞的声音。这座医院废弃了十年，但似乎从未真正安静过。",
    descriptionEn: "The light at the end of the corridor flickers. Somewhere in a ward, metal instruments clatter. This hospital has been abandoned for ten years — but it's never truly been quiet.",
    audioUrl: "/audio/abandoned-hospital.mp3",
    duration: 195,
    plays: 4521,
    image: "https://images.unsplash.com/photo-1509248961158-e54f6934749c?w=400&h=300&fit=crop",
    pricing: { personal: 0, perUse: 2, monthly: 9 },
    atmo: "night",
  },
  {
    id: "midnight-manor",
    name: "午夜凶宅",
    nameEn: "Midnight Manor",
    emoji: "🏚️",
    category: "horror",
    tags: ["凶宅", "午夜", "鬼魂", "古堡"],
    tagsEn: ["haunted", "midnight", "ghosts", "castle"],
    mood: ["阴森", "诡异", "神秘"],
    moodEn: ["eerie", "uncanny", "mysterious"],
    useCases: ["恐怖游戏", "广播剧", "万圣节"],
    useCasesEn: ["Horror Game", "Audio Drama", "Halloween"],
    description: "古老的庄园，大理石地板上倒映着摇晃的烛光。挂钟永远停在三点整，而楼梯上似乎总有看不见的脚步声。",
    descriptionEn: "An ancient manor — candlelight flickers across marble floors. The grandfather clock is stuck at 3:00, and invisible footsteps seem to haunt the staircase.",
    audioUrl: "/audio/midnight-manor.mp3",
    duration: 223,
    plays: 3892,
    image: "https://images.unsplash.com/photo-1519074069444-1ba4fff66d16?w=400&h=300&fit=crop",
    pricing: { personal: 0, perUse: 2, monthly: 9 },
    atmo: "night",
  },
  {
    id: "apocalypse-wasteland",
    name: "末日废土",
    nameEn: "Apocalypse Wasteland",
    emoji: "☢️",
    category: "horror",
    tags: ["末日", "废土", "荒凉", "毁灭"],
    tagsEn: ["apocalypse", "wasteland", "desolate", "ruin"],
    mood: ["绝望", "荒凉", "压迫"],
    moodEn: ["hopeless", "barren", "oppressive"],
    useCases: ["末日游戏", "电影配乐", "纪录片"],
    useCasesEn: ["Post-apocalyptic Game", "Film Score", "Documentary"],
    description: "最后一座城市已经倒下，天空永远是灰蒙蒙的。风沙中传来远处野兽的嚎叫，文明的遗迹正在被自然吞噬。",
    descriptionEn: "The last city has fallen. The sky is perpetually gray. Somewhere beyond the dust, beasts howl. The ruins of civilization are being reclaimed by nature.",
    audioUrl: "/audio/apocalypse-wasteland.mp3",
    duration: 267,
    plays: 2156,
    image: "https://images.unsplash.com/photo-1518709268805-4e9042af9f23?w=400&h=300&fit=crop",
    pricing: { personal: 0, perUse: 3, monthly: 9 },
    atmo: "autumn",
  },

  // === 古风 / 诗词 ===
  {
    id: "changan-night",
    name: "长安夜市",
    nameEn: "Chang'an Night Market",
    emoji: "🏮",
    category: "poetry",
    tags: ["唐朝", "夜市", "长安", "古风"],
    tagsEn: ["Tang Dynasty", "night market", "Chang'an", "vintage"],
    mood: ["繁华", "热闹", "古典"],
    moodEn: ["bustling", "lively", "classical"],
    useCases: ["古风视频", "游戏BGM", "纪录片"],
    useCasesEn: ["Period Video", "Game BGM", "Documentary"],
    description: "灯火通明的长安城，酒肆里传来胡姬的歌声。丝绸之路的起点，万国来朝的盛世夜景。",
    descriptionEn: "The lantern-lit streets of Chang'an. Singers perform in the taverns. The starting point of the Silk Road — a glorious night scene of a cosmopolitan empire.",
    audioUrl: "/audio/changan-night.mp3",
    duration: 234,
    plays: 5673,
    image: "https://images.unsplash.com/photo-1518998053901-5348d3961a04?w=400&h=300&fit=crop",
    pricing: { personal: 0, perUse: 2, monthly: 9 },
    atmo: "ancient",
  },
  {
    id: "desert-caravan",
    name: "大漠孤烟",
    nameEn: "Desert Caravan",
    emoji: "🐪",
    category: "poetry",
    tags: ["沙漠", "商队", "丝绸之路", "孤寂"],
    tagsEn: ["desert", "caravan", "silk road", "solitude"],
    mood: ["苍凉", "悠远", "孤独"],
    moodEn: ["melancholic", "distant", "lonely"],
    useCases: ["纪录片", "古风视频", "旅行vlog"],
    useCasesEn: ["Documentary", "Period Video", "Travel Vlog"],
    description: "驼铃悠悠，孤烟直上。商队行进在无垠的沙漠中，天边是敦煌的晚霞。丝绸之路，一段漫长而浪漫的旅程。",
    descriptionEn: "Camel bells ring out as smoke rises straight in the still air. A caravan crosses the endless desert beneath the sunset glow of Dunhuang. The Silk Road — a long, romantic journey.",
    audioUrl: "/audio/desert-caravan.mp3",
    duration: 289,
    plays: 3241,
    image: "https://images.unsplash.com/photo-1509316785289-025f5b846b35?w=400&h=300&fit=crop",
    pricing: { personal: 0, perUse: 2, monthly: 9 },
    atmo: "ancient",
  },
  {
    id: "jianghu-inn",
    name: "江湖客栈",
    nameEn: "Jianghu Tavern",
    emoji: "🍶",
    category: "poetry",
    tags: ["武侠", "客栈", "江湖", "酒"],
    tagsEn: ["wuxia", "tavern", "jianghu", "wine"],
    mood: ["豪迈", "侠义", "江湖气"],
    moodEn: ["heroic", "chivalrous", "wanderer's spirit"],
    useCases: ["武侠游戏", "古风视频", "短视频"],
    useCasesEn: ["Wuxia Game", "Period Video", "Short Video"],
    description: "江湖儿女，聚散无常。一壶浊酒喜相逢，刀光剑影里藏着一诺千金。这座客栈见证过太多故事。",
    descriptionEn: "Wanderers of the martial world come and go. A flask of wine for a chance reunion — beneath the flashing blades lies a promise worth keeping. This tavern has seen too many stories.",
    audioUrl: "/audio/jianghu-inn.mp3",
    duration: 198,
    plays: 6234,
    image: "https://images.unsplash.com/photo-1514933651103-005eec06c04b?w=400&h=300&fit=crop",
    pricing: { personal: 0, perUse: 2, monthly: 9 },
    atmo: "ancient",
  },

  // === 爵士 / 慵懒 ===
  {
    id: "velvet-night",
    name: "丝绒之夜",
    nameEn: "Velvet Night",
    emoji: "🌙",
    category: "female-lavish",
    tags: ["爵士", "丝绒", "夜晚", "慵懒"],
    tagsEn: ["jazz", "velvet", "night", "lazy"],
    mood: ["慵懒", "迷幻", "优雅"],
    moodEn: ["lazy", "dreamy", "elegant"],
    useCases: ["直播背景", "咖啡馆BGM", "夜间视频"],
    useCasesEn: ["Live Stream", "Café BGM", "Night Video"],
    description: "烟雾缭绕的爵士酒吧，萨克斯低吟浅唱。红裙女子倚在吧台，眼神里是一个时代的纸醉金迷。",
    descriptionEn: "A smoky jazz bar where the saxophone croons. A woman in red leans against the bar — her eyes hold the glamour and melancholy of a bygone era.",
    audioUrl: "/audio/velvet-night.mp3",
    duration: 267,
    plays: 4123,
    image: "https://images.unsplash.com/photo-1514525253161-7a46d19cd819?w=400&h=300&fit=crop",
    pricing: { personal: 0, perUse: 2, monthly: 9 },
    atmo: "cafe",
  },
  {
    id: "midnight-taxi",
    name: "午夜出租车",
    nameEn: "Midnight Taxi",
    emoji: "🚕",
    category: "female-lavish",
    tags: ["爵士", "夜晚", "城市", "孤独"],
    tagsEn: ["jazz", "night", "city", "loneliness"],
    mood: ["孤独", "沉思", "都市感"],
    moodEn: ["lonely", "contemplative", "urban"],
    useCases: ["夜间直播", "城市视频", "播客"],
    useCasesEn: ["Night Stream", "City Video", "Podcast"],
    description: "凌晨三点的出租车，窗外的霓虹灯一盏盏掠过。后视镜里司机沉默的脸，收音机里放着一首老爵士。",
    descriptionEn: "A taxi at 3 AM — neon lights streak past the window. In the rearview mirror, the driver's silent face. The radio plays an old jazz standard.",
    audioUrl: "/audio/midnight-taxi.mp3",
    duration: 189,
    plays: 2876,
    image: "https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=400&h=300&fit=crop",
    pricing: { personal: 0, perUse: 2, monthly: 9 },
    atmo: "night",
  },

  // === 男性低音 / 叙事 ===
  {
    id: "lonely-highway",
    name: "荒野公路",
    nameEn: "Lonely Highway",
    emoji: "🛣️",
    category: "male-deep",
    tags: ["公路", "牛仔", "孤独", "叙事"],
    tagsEn: ["highway", "cowboy", "loneliness", "storytelling"],
    mood: ["孤独", "自由", "苍凉"],
    moodEn: ["lonely", "free", "melancholic"],
    useCases: ["公路视频", "旅行vlog", "纪录片"],
    useCasesEn: ["Road Trip Video", "Travel Vlog", "Documentary"],
    description: "66号公路，日落到日出。皮卡车里的老收音机，一个男人，一辆车的无尽旅途。",
    descriptionEn: "Route 66, from sunset to sunrise. An old radio in a pickup truck. One man, one vehicle, an endless road ahead.",
    audioUrl: "/audio/lonely-highway.mp3",
    duration: 312,
    plays: 4532,
    image: "https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=400&h=300&fit=crop",
    pricing: { personal: 0, perUse: 2, monthly: 9 },
    atmo: "autumn",
  },
  {
    id: "noir-detective",
    name: "黑色侦探",
    nameEn: "Noir Detective",
    emoji: "🕵️",
    category: "male-deep",
    tags: ["侦探", "黑色电影", "爵士", "烟雾"],
    tagsEn: ["detective", "film noir", "jazz", "smoke"],
    mood: ["神秘", "沧桑", "孤独"],
    moodEn: ["mysterious", "world-weary", "lonely"],
    useCases: ["侦探剧", "短视频", "游戏BGM"],
    useCasesEn: ["Detective Show", "Short Video", "Game BGM"],
    description: "雨夜，侦探事务所的灯牌忽明忽暗。案子结了，但真相永远藏在某个女人消失的背影里。",
    descriptionEn: "A rainy night. The detective agency's sign flickers. The case is closed, but the truth is always hidden in the fading silhouette of a woman walking away.",
    audioUrl: "/audio/noir-detective.mp3",
    duration: 245,
    plays: 3298,
    image: "https://images.unsplash.com/photo-1478720568477-152d9b164e26?w=400&h=300&fit=crop",
    pricing: { personal: 0, perUse: 2, monthly: 9 },
    atmo: "night",
  },
];

export const categories = [
  { id: "all", name: "全部", nameEn: "All", color: "#6366f1" },
  { id: "relaxing", name: "放松", nameEn: "Relaxing", color: "#10b981" },
  { id: "tense", name: "紧张", nameEn: "Tense", color: "#f59e0b" },
  { id: "horror", name: "恐怖", nameEn: "Horror", color: "#7c3aed" },
  { id: "poetry", name: "古风", nameEn: "Poetry", color: "#ec4899" },
  { id: "female-lavish", name: "慵懒", nameEn: "Lush", color: "#06b6d4" },
  { id: "male-deep", name: "叙事", nameEn: "Narrative", color: "#84cc16" },
];

export const useCases = [
  "视频剪辑",
  "游戏BGM",
  "直播背景",
  "播客",
  "冥想引导",
  "纪录片",
  "预告片",
  "短视频",
];
